export function getSessionId() {
    const storedSessionId = localStorage.getItem('sessionId');
  
    if (storedSessionId) {
      return storedSessionId;
    } else {
      const newSessionId = generateNewSessionId();
      localStorage.setItem('sessionId', newSessionId);
      return newSessionId;
    }
  }
  
  function generateNewSessionId() {
    const randomValue = Math.random();
    const timestamp = new Date().getTime();
    const sessionId = `${randomValue}-${timestamp}`;
    return sessionId;
  }